<template>
  <div class="popup z-index-10-fg confirmation small-popup quote-filter-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Filter Quotes</h2>
        <img src="@/assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />
      </div>
      <div class="popup-body">
        <Dropdown :options="salespeopleWithAll" label="Salesperson" v-model="filters.salespersonId" class="input-item large-item" />
        <MultiDropdown :options="statusOptions" label="Status" v-model="filters.statuses" :showSelectAll="true" class="input-item large-item" />
        <h3>Created Date</h3>
        <div class="primary-input input-item small-item">
          <input type="date" v-model="filters.dateCreatedFrom" />
          <label>From</label>
        </div>
        <div class="primary-input input-item small-item">
          <input type="date" v-model="filters.dateCreatedTo" />
          <label>To</label>
        </div>
        <h3>Date Required</h3>
        <div class="primary-input input-item small-item">
          <input type="date" v-model="filters.dateRequiredFrom" />
          <label>From</label>
        </div>
        <div class="primary-input input-item small-item">
          <input type="date" v-model="filters.dateRequiredTo" />
          <label>To</label>
        </div>
      </div>
      <div class="popup-footer">
        <button @click="resetFilters()" class="text-btn">reset</button>
        <button class="square-btn" @click="$emit('closePopup')">Save</button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import Dropdown from '@/components/inputs/Dropdown.vue';
import MultiDropdown from '@/components/inputs/MultiDropdown.vue';
import useQuotesQuery from '@/composables/useQuotesQuery';
import useUsersQuery from '@/composables/useUsersQuery';
import useCurrentUser from '@/composables/useCurrentUser';

export default {
  name: 'QuoteFilter',
  emits: ['closePopup'],
  components: {
    Dropdown,
    MultiDropdown,
  },
  setup() {
    const { salespeople, outsideSalespeople, allActiveUsers } = useUsersQuery();
    const { user } = useCurrentUser();

    return {
      filters: useQuotesQuery.filters,
      salespeople,
      outsideSalespeople,
      allActiveUsers,
      user,
    };
  },
  data() {
    return {
      statusOptions: [
        { key: 'open', value: 'Open' },
        { key: 'rejected', value: 'Rejected' },
        { key: 'converted', value: 'Converted' },
      ],
    };
  },
  computed: {
    salespeopleWithAll() {
      const seen = new Set();
      const combined = [...this.salespeople, ...this.outsideSalespeople, ...this.allActiveUsers].filter((salesperson) => {
        if (seen.has(salesperson.USERID)) return false;
        seen.add(salesperson.USERID);
        return salesperson.INSIDESALES || salesperson.OUTSIDESALES;
      });
      combined.sort((a, b) => a.DISPLAYNAME.localeCompare(b.DISPLAYNAME));
      const options = combined.map((salesperson) => ({ text: salesperson.DISPLAYNAME, value: salesperson.USERID }));
      return [{ text: 'All', value: null }, ...options];
    },
  },
  methods: {
    resetFilters() {
      this.filters.salespersonId = this.user.userid;
      this.filters.statuses = ['open', 'converted'];
      this.filters.dateCreatedFrom = null;
      this.filters.dateCreatedTo = null;
      this.filters.dateRequiredFrom = null;
      this.filters.dateRequiredTo = null;
      this.$emit('closePopup');
    },
  },
};
</script>

<style lang="scss" scoped>
.quote-filter-popup {
  width: 25rem;

  .popup-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1.5rem 1rem;

    h3 {
      width: 100%;
      margin: 0;
      color: $textColor87;
    }

    .input-item {
      min-width: 20rem;
      flex: 1 0 45%;

      &.small-item {
        min-width: 5rem;
        flex: 1 0 10%;
      }

      &.large-item {
        min-width: 20rem;
        flex: 1 0 90%;
      }
    }
  }
}
</style>
